<template>
  <div class="ors-i-tb">
    <v-container>
      <v-toolbar
        :extended="extended"
        :extension-height="extensionHeight"
        elevation="0"
      >
        <v-icon
          v-if="titleIcon"
          color="primary"
        >
          {{ titleIcon }}
        </v-icon>
        <v-toolbar-title v-if="title">
          {{ title }}
        </v-toolbar-title>
        <v-spacer />
        <v-toolbar-items>
          <slot />
        </v-toolbar-items>
        <template
          v-if="extended"
          #extension
        >
          <slot name="extension" />
        </template>
      </v-toolbar>
    </v-container>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: () => null,
    },
    titleIcon: {
      type: String,
      default: () => null,
    },
    extended: {
      type: Boolean,
      default: () => false,
    },
    extensionHeight: {
      type: [Number, String],
      default: () => null,
    },
  },
};
</script>

<style lang="css" scoped>
@import '~@/style/variables.css';
.ors-i-tb {
  background-color: var(--secondary-color-3);
}

.ors-i-tb /deep/ .v-toolbar {
  background: transparent;
}

.ors-i-tb /deep/ .v-toolbar__content {
  margin: 0;
  padding: 0;
}

.ors-i-tb /deep/ .v-toolbar__title {
  margin-left: 8px;
  color: var(--primary-color-3);
  font-weight: 500;
  font-size: 24px;
}

.ors-i-tb /deep/ .v-toolbar__items > .v-btn {
  height: 34px !important;
  border-radius: 999px;
  margin: auto 0;
}
</style>
